import { environment } from "./../../../../environments/environment";
import { catchError } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import {
  HandleError,
  HttpErrorHandler
} from "./../../../util/http-error-handler.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Notificacao } from "../../../models/notificacao/notificacao";

const API_URL = environment.apiUrl;

@Injectable({
  providedIn: "root"
})
export class RelatorioClienteRecorrenteService {
  private handleError: HandleError;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError("RelatorioClienteRecorrenteService");
  }

  obterTodos(param: any, direcao: string, propriedade: string): Observable<any> {
    const params = new HttpParams()
      .set('Direcao', `${(direcao)}`)
      .set('Propriedade', `${(propriedade)}`)
      .set("pageNumber", `${param.offset}`)
      .set("pageSize", `${param.limit}`);
    return this.http
      .get<any>(`${API_URL}/v1/recurringcustomers`, { params })
      .pipe(catchError(this.handleError("obter-todas", [])));
  }

}
